import axios from 'axios'
import { constants as C } from './constants'

export const insertUsert = (user) => {
    return axios.post(C.USERS_ENDPOINT, user)
}